export class LayoutSettings {
  public static getLayoutSettings() {
    return {
      LAYOUT_MODE_TYPES: "light",
      DATA_LAYOUT_MODE: "vertical",
      LAYOUT_WIDTH_TYPES: "fluid",
      SIDEBAR_TYPE: "dark",
      TOPBAR_MODE_TYPES: "light",
    };
  }
}
